// @flow

import { Environment } from 'relay-runtime';
import { commitMutation, graphql } from 'react-relay';

const addMutation = graphql`
	mutation InfoStringAddMutation($input: InfoStringAddInput!) {
		InfoStringAdd(input: $input) {
            error
			infoStringEdge {
				node {
					id
				}
			}
		}
	}
`;

export function commit(environment: Environment, params: any, callback: (error: ?Error, id: ?string) => void) {
	commitMutation(environment, {
		mutation: addMutation,
		variables: {
			input: params,
		},
		onCompleted: response => {
			const {error, userEdge} = response.InfoStringAdd;
			if (error) {
				callback(error, null);
				return;
			}

			callback(null, userEdge);
		},
		onError: error => {
			console.log('error mutating');
			console.log(error);
			callback(error, null);
		},
	});
}



// WEBPACK FOOTER //
// src/mutations/InfoStringAddMutation.js